<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="calendar-header mb-2">
          <div class="calendar-header__title">
            {{ currentHeaderLabel }}
          </div>
          <div class="calendar-header__actions">
            <div class="calendar-legend">
              <span class="legend-item">
                <span class="legend-dot legend-dot--hito"></span>
                <span i18n>Hito</span>
              </span>
              <span class="legend-item">
                <span class="legend-dot legend-dot--dia-inhabil"></span>
                <span i18n>Día inhábil</span>
              </span>
            </div>
            <div class="calendar-nav">
              <button type="button" class="btn btn-light btn-sm" (click)="navigatePrev()">
                <i class="mdi mdi-chevron-left"></i>
              </button>
              <button type="button" class="btn btn-light btn-sm" (click)="navigateToday()" i18n>Hoy</button>
              <button type="button" class="btn btn-light btn-sm" (click)="navigateNext()">
                <i class="mdi mdi-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="calendar-filters mb-2">
          <div class="calendar-filter">
            <label for="hitosFilter" class="form-label mb-0" i18n>Filtrar hitos</label>
            <select id="hitosFilter" class="form-select form-select-sm"
              [(ngModel)]="selectedFilter" (ngModelChange)="onFilterChange($event)">
              <option value="mine" i18n>Hitos de mis casos</option>
              <option value="all" i18n>TODOS</option>
              <option *ngFor="let user of adminUsers" [value]="'user:' + user.id">
                {{ getAdminLabel(user) }}
              </option>
            </select>
          </div>
          <div class="calendar-filter">
            <label for="casosFilter" class="form-label mb-0" i18n>Filtrar casos</label>
            <select id="casosFilter" class="form-select form-select-sm"
              [(ngModel)]="selectedCaseFilter" (ngModelChange)="onCaseFilterChange($event)">
              <option value="all" i18n>TODOS</option>
              <option *ngFor="let caso of availableCases" [value]="caso.id">
                {{ caso.label }} ({{ caso.count }})
              </option>
            </select>
          </div>
        </div>

        <div id="calendar" *ngIf="loaded && !error">
          <full-calendar #calendar [options]="calendarOptions"></full-calendar>
        </div>

        <div id="status" *ngIf="!loaded && !error">
          <div class="spinner">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <ngb-alert [dismissible]="false" type="danger" *ngIf="error">
          {{ error }}
        </ngb-alert>
      </div>
    </div>
  </div>
</div>

<ng-template #dayModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <span i18n>Detalle del día</span>
      <span *ngIf="selectedDayLabel">: {{ selectedDayLabel }}</span>
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.close()"></button>
  </div>
  <div class="modal-body">
    <div *ngIf="selectedDayHitos.length === 0" class="text-muted" i18n>
      No hay hitos para este día.
    </div>

    <div *ngIf="selectedDayGroups.length > 0">
      <div class="hito-group" *ngFor="let group of selectedDayGroups">
        <div class="hito-group-title">
          <span i18n>Caso</span> - {{ group.caseLabel }}
          <a *ngIf="group.caseId" [routerLink]="['/casos/gestion', group.caseId]"
            class="case-link" title="Abrir caso" i18n-title (click)="modal.close()">
            <i class="fe-link"></i>
          </a>
        </div>
        <div class="list-group hito-list">
          <div class="list-group-item hito-list-item" *ngFor="let hito of group.hitos">
            <div class="hito-list-title">
              <span class="badge hito-day-badge"
                [ngClass]="isDiaInhabil(hito) ? 'bg-dark' : 'bg-primary'">
                {{ getTipoLabel(hito.tipo) }}
              </span>
              {{ getDayListLine(hito) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()" i18n>Cerrar</button>
  </div>
</ng-template>

<ng-template #hitoModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title hito-modal-title">
      <span class="badge"
        [ngClass]="selectedHito && isDiaInhabil(selectedHito) ? 'bg-dark' : 'bg-primary'">
        {{ selectedHito ? getTipoLabel(selectedHito.tipo) : '' }}
      </span>
      <span *ngIf="selectedHito">{{ getHitoModalTitle(selectedHito) }}</span>
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.close()"></button>
  </div>
  <div class="modal-body" *ngIf="selectedHito">
    <div class="mb-3">
      <div class="text-muted" i18n>Caso</div>
      <div class="fw-semibold d-flex align-items-center gap-2">
        {{ (selectedHito.numero_expediente || selectedHito.id_expediente) || '-' }}
        <a *ngIf="selectedHito.id_expediente" [routerLink]="['/casos/gestion', selectedHito.id_expediente]"
          class="case-link" title="Abrir caso" i18n-title (click)="modal.close()">
          <i class="fe-link"></i>
        </a>
      </div>
    </div>

    <div class="mb-3">
      <div class="text-muted" i18n>Descripción</div>
      <div class="fw-semibold">{{ selectedHito.descripcion || '-' }}</div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()" i18n>Cerrar</button>
  </div>
</ng-template>
